import {urlGenerator} from "../../../application/helpers/AxiosHelper";
import {USER_GALLERY} from "../../../application/config/ApiUrl";
import axios from 'axios';

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        list: [],
    }),
    mutations: {
        SET_LOADING: (state, payloads) => state.loading = payloads,
        SET_LIST: (state, payloads) => state.list = payloads,
    },
    actions: {
        getAll: (context, {loader = true, id}) => {
            if(!context.state.no_more) {
                context.commit('SET_LOADING', loader)
                return axios.get(urlGenerator(USER_GALLERY+ id))
                    .then(res => {
                        context.commit('SET_LIST', [ ...context.state.list, ...res.data])
                    })
                    .finally(() => context.commit('SET_LOADING', false))
            }
        }
    },
    getters: {
        loading: state => state.loading,
        list: state => state.list.map(item => item.full_url),
    }
}
